// Rugby World Cup 2027 (Australie) - Programme complet officiel (52 matchs)
// Source : fichier WC2027.2.xlsx fourni par l'utilisateur
// Nommage STANDARD des événements : "M{N} -( {STAGE} ) - {teams}"

export const RUGBY_MATCHES = [
  // ============ PHASE DE POULES ============
  { matchNum: 1, date: "01/10/2027", time: "18:45", stage: "POOL A", teams: "Australia vs Hong Kong China", venue: "Perth Stadium", city: "Perth" },
  { matchNum: 2, date: "02/10/2027", time: "12:15", stage: "POOL F", teams: "Wales vs Zimbabwe", venue: "Adelaide Oval", city: "Adelaide" },
  { matchNum: 3, date: "02/10/2027", time: "13:15", stage: "POOL A", teams: "New Zealand vs Chile", venue: "Perth Stadium", city: "Perth" },
  { matchNum: 4, date: "02/10/2027", time: "17:45", stage: "POOL E", teams: "France vs USA", venue: "Docklands Stadium", city: "Melbourne" },
  { matchNum: 5, date: "02/10/2027", time: "20:15", stage: "POOL F", teams: "England vs Tonga", venue: "Brisbane Stadium", city: "Brisbane" },
  { matchNum: 6, date: "03/10/2027", time: "12:15", stage: "POOL E", teams: "Japan vs Samoa", venue: "Newcastle Stadium", city: "Newcastle" },
  { matchNum: 7, date: "03/10/2027", time: "14:15", stage: "POOL B", teams: "South Africa vs Italy", venue: "Adelaide Oval", city: "Adelaide" },
  { matchNum: 8, date: "03/10/2027", time: "17:15", stage: "POOL D", teams: "Scotland vs Uruguay", venue: "Docklands Stadium", city: "Melbourne" },
  { matchNum: 9, date: "03/10/2027", time: "20:15", stage: "POOL B", teams: "Georgia vs Romania", venue: "North Queensland Stadium", city: "Townsville" },
  { matchNum: 10, date: "04/10/2027", time: "14:15", stage: "POOL C", teams: "Fiji vs Spain", venue: "Newcastle Stadium", city: "Newcastle" },
  { matchNum: 11, date: "04/10/2027", time: "17:15", stage: "POOL D", teams: "Ireland vs Portugal", venue: "Sydney Football Stadium", city: "Sydney" },
  { matchNum: 12, date: "04/10/2027", time: "18:45", stage: "POOL C", teams: "Argentina vs Canada", venue: "Brisbane Stadium", city: "Brisbane" },
  { matchNum: 13, date: "08/10/2027", time: "18:15", stage: "POOL F", teams: "Wales vs Tonga", venue: "Docklands Stadium", city: "Melbourne" },
  { matchNum: 14, date: "08/10/2027", time: "20:15", stage: "POOL F", teams: "England vs Zimbabwe", venue: "Adelaide Oval", city: "Adelaide" },
  { matchNum: 15, date: "09/10/2027", time: "12:15", stage: "POOL E", teams: "USA vs Samoa", venue: "Perth Stadium", city: "Perth" },
  { matchNum: 16, date: "09/10/2027", time: "17:10", stage: "POOL A", teams: "New Zealand vs Australia", venue: "Stadium Australia", city: "Sydney" },
  { matchNum: 17, date: "09/10/2027", time: "18:45", stage: "POOL E", teams: "France vs Japan", venue: "Brisbane Stadium", city: "Brisbane" },
  { matchNum: 18, date: "09/10/2027", time: "20:15", stage: "POOL A", teams: "Chile vs Hong Kong China", venue: "North Queensland Stadium", city: "Townsville" },
  { matchNum: 19, date: "10/10/2027", time: "12:15", stage: "POOL C", teams: "Fiji vs Canada", venue: "Adelaide Oval", city: "Adelaide" },
  { matchNum: 20, date: "10/10/2027", time: "15:15", stage: "POOL C", teams: "Argentina vs Spain", venue: "Docklands Stadium", city: "Melbourne" },
  { matchNum: 21, date: "10/10/2027", time: "16:45", stage: "POOL B", teams: "South Africa vs Georgia", venue: "Brisbane Stadium", city: "Brisbane" },
  { matchNum: 22, date: "10/10/2027", time: "17:45", stage: "POOL D", teams: "Ireland vs Scotland", venue: "Perth Stadium", city: "Perth" },
  { matchNum: 23, date: "11/10/2027", time: "17:15", stage: "POOL D", teams: "Uruguay vs Portugal", venue: "Newcastle Stadium", city: "Newcastle" },
  { matchNum: 24, date: "11/10/2027", time: "19:45", stage: "POOL B", teams: "Italy vs Romania", venue: "Sydney Football Stadium", city: "Sydney" },
  { matchNum: 25, date: "15/10/2027", time: "17:15", stage: "POOL A", teams: "New Zealand vs Hong Kong China", venue: "Docklands Stadium", city: "Melbourne" },
  { matchNum: 26, date: "15/10/2027", time: "20:00", stage: "POOL E", teams: "Japan vs USA", venue: "Adelaide Oval", city: "Adelaide" },
  { matchNum: 27, date: "15/10/2027", time: "20:15", stage: "POOL F", teams: "Tonga vs Zimbabwe", venue: "North Queensland Stadium", city: "Townsville" },
  { matchNum: 28, date: "16/10/2027", time: "13:15", stage: "POOL C", teams: "Argentina vs Fiji", venue: "Adelaide Oval", city: "Adelaide" },
  { matchNum: 29, date: "16/10/2027", time: "15:10", stage: "POOL A", teams: "Australia vs Chile", venue: "Brisbane Stadium", city: "Brisbane" },
  { matchNum: 30, date: "16/10/2027", time: "19:45", stage: "POOL F", teams: "England vs Wales", venue: "Stadium Australia", city: "Sydney" },
  { matchNum: 31, date: "16/10/2027", time: "20:15", stage: "POOL C", teams: "Spain vs Canada", venue: "North Queensland Stadium", city: "Townsville" },
  { matchNum: 32, date: "17/10/2027", time: "12:15", stage: "POOL B", teams: "Italy vs Georgia", venue: "Newcastle Stadium", city: "Newcastle" },
  { matchNum: 33, date: "17/10/2027", time: "14:45", stage: "POOL D", teams: "Ireland vs Uruguay", venue: "Docklands Stadium", city: "Melbourne" },
  { matchNum: 34, date: "17/10/2027", time: "16:15", stage: "POOL D", teams: "Scotland vs Portugal", venue: "Brisbane Stadium", city: "Brisbane" },
  { matchNum: 35, date: "17/10/2027", time: "19:45", stage: "POOL E", teams: "France vs Samoa", venue: "Sydney Football Stadium", city: "Sydney" },
  { matchNum: 36, date: "17/10/2027", time: "19:15", stage: "POOL B", teams: "South Africa vs Romania", venue: "Perth Stadium", city: "Perth" },
  // ============ HUITIÈMES DE FINALE (R16) ============
  { matchNum: 37, date: "23/10/2027", time: "14:15", stage: "R16", teams: "2nd Pool C vs 2nd Pool F", venue: "Sydney Football Stadium", city: "Sydney" },
  { matchNum: 38, date: "23/10/2027", time: "15:45", stage: "R16", teams: "1st Pool A vs 3rd Pool C/E/F", venue: "Brisbane Stadium", city: "Brisbane" },
  { matchNum: 39, date: "23/10/2027", time: "19:15", stage: "R16", teams: "1st Pool E vs 2nd Pool D", venue: "Docklands Stadium", city: "Melbourne" },
  { matchNum: 40, date: "23/10/2027", time: "18:45", stage: "R16", teams: "À déterminer", venue: "Perth Stadium", city: "Perth" },
  { matchNum: 41, date: "24/10/2027", time: "14:15", stage: "R16", teams: "1st Pool C vs 3rd Pool A/B/F", venue: "Sydney Football Stadium", city: "Sydney" },
  { matchNum: 42, date: "24/10/2027", time: "16:45", stage: "R16", teams: "À déterminer", venue: "Docklands Stadium", city: "Melbourne" },
  { matchNum: 43, date: "24/10/2027", time: "18:15", stage: "R16", teams: "2nd Pool A vs 2nd Pool E", venue: "Brisbane Stadium", city: "Brisbane" },
  { matchNum: 44, date: "24/10/2027", time: "18:45", stage: "R16", teams: "1st Pool F vs 2nd Pool B", venue: "Perth Stadium", city: "Perth" },
  // ============ QUARTS DE FINALE ============
  { matchNum: 45, date: "30/10/2027", time: "16:45", stage: "QUART DE FINALE", teams: "Winner R16-2 vs Winner R16-4", venue: "Stadium Australia", city: "Sydney" },
  { matchNum: 46, date: "30/10/2027", time: "18:45", stage: "QUART DE FINALE", teams: "Winner R16-1 vs Winner R16-3", venue: "Brisbane Stadium", city: "Brisbane" },
  { matchNum: 47, date: "31/10/2027", time: "16:00", stage: "QUART DE FINALE", teams: "Winner R16-5 vs Winner R16-6", venue: "Brisbane Stadium", city: "Brisbane" },
  { matchNum: 48, date: "31/10/2027", time: "20:00", stage: "QUART DE FINALE", teams: "Winner R16-7 vs Winner R16-8", venue: "Stadium Australia", city: "Sydney" },
  // ============ DEMI-FINALES ============
  { matchNum: 49, date: "05/11/2027", time: "20:00", stage: "DEMI-FINALE", teams: "Winner QF1 vs Winner QF2", venue: "Stadium Australia", city: "Sydney" },
  { matchNum: 50, date: "06/11/2027", time: "20:00", stage: "DEMI-FINALE", teams: "Winner QF3 vs Winner QF4", venue: "Stadium Australia", city: "Sydney" },
  // ============ FINALES ============
  { matchNum: 51, date: "12/11/2027", time: "19:45", stage: "BRONZE", teams: "Runner-up SF1 vs Runner-up SF2", venue: "Stadium Australia", city: "Sydney" },
  { matchNum: 52, date: "13/11/2027", time: "20:00", stage: "FINALE", teams: "Winner SF1 vs Winner SF2", venue: "Stadium Australia", city: "Sydney" },
];

// Normalise un numéro de match rugby : "M12", "012", "match 12", "#12" → 12
export const normalizeRugbyMatchNumber = (input) => {
  if (!input) return null;
  const str = String(input).trim().toLowerCase();

  const patterns = [
    /^m?0*(\d{1,2})$/i,
    /^match\s*(\d{1,2})$/i,
    /^game\s*(\d{1,2})$/i,
    /^#(\d{1,2})$/i,
  ];

  for (const pattern of patterns) {
    const match = str.match(pattern);
    if (match) {
      const num = parseInt(match[1], 10);
      if (num >= 1 && num <= 52) return num;
    }
  }

  const directNum = parseInt(str, 10);
  if (!isNaN(directNum) && directNum >= 1 && directNum <= 52) return directNum;
  return null;
};

export const getRugbyMatchByNumber = (matchNum) => {
  const num = typeof matchNum === 'number' ? matchNum : normalizeRugbyMatchNumber(matchNum);
  if (!num) return null;
  return RUGBY_MATCHES.find(m => m.matchNum === num);
};

// Nom d'événement STANDARD (toujours écrit pareil) : "M1 -( POOL A ) - Australia vs Hong Kong China"
export const getRugbyMatchDisplayName = (matchNum) => {
  const match = getRugbyMatchByNumber(matchNum);
  if (!match) return null;
  return `M${match.matchNum} -( ${match.stage} ) - ${match.teams}`;
};

// "M4 -( POOL E ) - France vs USA" → { stage: "POOL E", teams: "France vs USA" }
export const splitRugbyEventName = (evenement) => {
  const m = (evenement || '').match(/^M\d+\s*-\(\s*([^)]*)\)\s*-\s*(.+)$/i);
  if (m) return { stage: m[1].trim(), teams: m[2].trim() };
  return null;
};

// Alias d'équipes (noms marketplace ≠ noms officiels)
const TEAM_ALIASES = {
  'usa': ['usa', 'united states'],
  'hong kong china': ['hong kong china', 'hong kong'],
};
const teamInText = (text, team) => {
  const aliases = TEAM_ALIASES[team] || [team];
  return aliases.some(a => text.includes(a));
};

// Normalise ville/lieu marketplace → ville officielle du calendrier
const CITY_ALIASES = {
  'docklands': 'Melbourne', 'narrm': 'Melbourne', 'melbourne': 'Melbourne',
  'burswood': 'Perth', 'boorloo': 'Perth', 'perth': 'Perth',
  'north adelaide': 'Adelaide', 'tarntanya': 'Adelaide', 'adelaide': 'Adelaide',
  'meeanjin': 'Brisbane', 'brisbane': 'Brisbane',
  'gurambilbarra': 'Townsville', 'townsville': 'Townsville',
  'awabakal': 'Newcastle', 'newcastle': 'Newcastle',
  'gadigal': 'Sydney', 'wangal': 'Sydney', 'homebush': 'Sydney', 'sydney': 'Sydney',
};
export const normalizeRugbyCity = (raw) => {
  if (!raw) return null;
  const lower = String(raw).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  for (const [alias, city] of Object.entries(CITY_ALIASES)) {
    if (lower.includes(alias)) return city;
  }
  return null;
};

// Normalise une date "17/10/2027", "2027-10-17", "17 Oct" → "17/10/2027"
const normalizeRugbyDate = (raw) => {
  if (!raw) return null;
  const s = String(raw).trim();
  const fr = s.match(/^(\d{1,2})[/\-.](\d{1,2})(?:[/\-.](\d{2,4}))?/);
  if (fr) return `${fr[1].padStart(2, '0')}/${fr[2].padStart(2, '0')}/2027`;
  const iso = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (iso) return `${iso[3]}/${iso[2]}/2027`;
  return null;
};

// Détecte un match rugby depuis un texte libre : "M12", "Argentina v Canada",
// "Winner SF 1 vs Winner SF 2 - Final", "1st Pool E vs 2nd Pool D - Round of 16"...
// dateRaw + cityRaw (optionnels) servent de repli infaillible pour les phases finales.
export const detectRugbyMatchFromText = (input, dateRaw = null, cityRaw = null) => {
  if (!input) return null;
  const str = String(input).trim();

  // 1. Numéro de match explicite
  const numMatch = str.match(/\bM\s*0*(\d{1,2})\b/i) || str.match(/\bmatch\s*0*(\d{1,2})\b/i);
  if (numMatch) {
    const num = parseInt(numMatch[1], 10);
    if (num >= 1 && num <= 52) return getRugbyMatchByNumber(num);
  }

  const lower = str.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  // Version compacte pour détecter "Quarter - Final", "Semi-Final", "Round of 16"...
  const compact = lower.replace(/[\s\-–—]+/g, '');

  // 2. Par équipes ("France v USA", "France vs United States", "Chile vs Hong Kong")
  for (const m of RUGBY_MATCHES) {
    const [t1, t2] = m.teams.split(' vs ').map(t => t.toLowerCase());
    if (!t1 || !t2 || t1.includes('determiner') || t1.includes('winner') || t1.includes('pool') || t1.includes('runner')) continue;
    if (teamInText(lower, t1) && teamInText(lower, t2)) return m;
  }

  // 3. Phases finales (noms marketplace)
  const isBronze = compact.includes('bronzefinal') || compact.includes('bronze');
  const isSemi = compact.includes('semifinal');
  const isQuarter = compact.includes('quarterfinal');
  const isR16 = compact.includes('roundof16') || /\br16\b/.test(lower);
  const isFinal = compact.includes('final') && !isBronze && !isSemi && !isQuarter;

  if (isBronze) return getRugbyMatchByNumber(51);
  if (isSemi) {
    const qfNums = [...lower.matchAll(/qf\s*\(?\s*0*(\d)\s*\)?/g)].map(x => parseInt(x[1], 10));
    if (qfNums.some(n => n === 1 || n === 2)) return getRugbyMatchByNumber(49);
    if (qfNums.some(n => n === 3 || n === 4)) return getRugbyMatchByNumber(50);
    // Repli par date: 05/11 = SF1, 06/11 = SF2
    const d = normalizeRugbyDate(dateRaw);
    if (d === '05/11/2027') return getRugbyMatchByNumber(49);
    if (d === '06/11/2027') return getRugbyMatchByNumber(50);
  }
  if (isQuarter) {
    const r16Nums = [...lower.matchAll(/r16\s*\(?\s*0*(\d)\s*\)?/g)].map(x => parseInt(x[1], 10));
    if (r16Nums.some(n => n === 2 || n === 4)) return getRugbyMatchByNumber(45);
    if (r16Nums.some(n => n === 1 || n === 3)) return getRugbyMatchByNumber(46);
    if (r16Nums.some(n => n === 5 || n === 6)) return getRugbyMatchByNumber(47);
    if (r16Nums.some(n => n === 7 || n === 8)) return getRugbyMatchByNumber(48);
  }
  if (isR16) {
    // Qualifiés de poule connus (ordre : les plus spécifiques d'abord)
    if (/2nd\s*pool\s*c/.test(lower) || /2nd\s*pool\s*f/.test(lower)) return getRugbyMatchByNumber(37);
    if (/1st\s*pool\s*a/.test(lower)) return getRugbyMatchByNumber(38);
    if (/1st\s*pool\s*e/.test(lower) || /2nd\s*pool\s*d/.test(lower)) return getRugbyMatchByNumber(39);
    if (/1st\s*pool\s*c/.test(lower)) return getRugbyMatchByNumber(41);
    if (/2nd\s*pool\s*a/.test(lower) || /2nd\s*pool\s*e/.test(lower)) return getRugbyMatchByNumber(43);
    if (/1st\s*pool\s*f/.test(lower) || /2nd\s*pool\s*b/.test(lower)) return getRugbyMatchByNumber(44);
  }
  if (isFinal) return getRugbyMatchByNumber(52);

  // 4. Repli infaillible : date (+ ville si plusieurs matchs le même jour)
  const d = normalizeRugbyDate(dateRaw);
  if (d) {
    let candidates = RUGBY_MATCHES.filter(m => m.date === d);
    if (candidates.length === 1) return candidates[0];
    const city = normalizeRugbyCity(cityRaw);
    if (city && candidates.length > 1) {
      const byCity = candidates.filter(m => m.city === city);
      if (byCity.length === 1) return byCity[0];
    }
  }
  return null;
};
